import { CONTROLLERS } from '../helpers/controllers'

import type { Component } from '../models/types'
import type { ControllerValue } from '../helpers/controllers'

export const USER_DATA_FRAGMENT = 'data-user-data'

export function componentControllerFragment(component: Component): string {
  return `${valueFragment('component', 'key', component.key)} ${valueFragment(
    'component',
    'type',
    `${component.type}`
  )}`
}

export function valueFragment(controller: string, key: string, value: string): string {
  return `data-${controller}-${key}-value="${value}"`
}

export function controllerFragment(controllerNames: string | string[]): string {
  return Array.isArray(controllerNames)
    ? `data-controller="${controllerNames.join(' ')}"`
    : `data-controller="${controllerNames}"`
}

export function targetFragment(controllerName: string, targetName: string): string {
  return `data-${controllerName}-target="${targetName}"`
}

//* ------------------------------------------------------------
//* Stimulus attributes
//* ------------------------------------------------------------

export const STIMULUS_ATTRIBUTES = {
  [CONTROLLERS.flow]: {
    disableAllInteractionsDuringTransitions: 'disable-all-interactions-during-transitions',
  },
} as const satisfies Partial<Record<ControllerValue, Record<string, string>>>

type StimulusAttributes = typeof STIMULUS_ATTRIBUTES
export type StimulusController = keyof StimulusAttributes & ControllerValue
type StimulusValueKey<C extends StimulusController> =
  StimulusAttributes[C][keyof StimulusAttributes[C]]

export function getStimulusValueAttr<C extends StimulusController>({
  controller,
  key,
}: {
  controller: C
  key: StimulusValueKey<C>
}): string {
  return `data-${controller}-${key}-value`
}
